import styled from "@emotion/styled";
import { IStyledComponentProps } from "../../../../theme/theme.types";

const SearchComponent = styled.div<IStyledComponentProps>`
  &.search-component {
    padding: 0;
    margin: 0;
    width: 60%;

    #SearchProjectsForm {
      margin: 0;
      padding: 0;
      outline: 0 none;

      .input-form-group {
        width: 100%;
      }

      .search-input,
      .search-button {
        background: 0 none;
        background-color: ${({ theme }) =>
          theme.colors.essential.white} !important;
        border: 1px solid ${({ theme }) => theme.colors.grays.septenary};
        border-radius: 0;
        outline: 0 none;
      }

      .search-input {
        border-right: 0 none;
        &.is-valid {
          border: 1px solid ${({ theme }) => theme.colors.grays.septenary};
          border-right: 0 none;
        }
      }
      .search-button {
        border-left: 0 none;
      }

      .search-input-group {
        height: 54px;
      }

      .clear-button-group {
        height: 54px;
        margin-left: 16px;
        align-self: flex-start;
        .clear-button {
          height: 100%;

          .clear-label {
            margin-right: 8px;
          }
        }
      }

      .form-text-prompt {
        color: ${({ theme }) => theme.colors.grays.septenary};
        font-size: ${({ theme }) => theme.fontSizes.smallest}px;
        &.invalid {
          color: ${({ theme }) => theme.colors.alerts.primary};
        }

        p {
          margin: 4px 2px;
        }
      }
    }

    @media (max-width: ${(props) =>
        props.theme.utils.getThemeBreakpoint("tablet")}) {
      width: 100%;
    }
  }
`;

export default { SearchComponent };
